module.exports = __webpack_public_path__ + "img/you-plus-people-img.cd6190d3.jpg";